import React from 'react';
import { ActivityEntry, ActivityIcon } from '../customerDetailsTypes';
import styles from './ActivityTimelineCard.module.css';

interface ActivityTimelineCardProps {
  entries: ActivityEntry[];
}

const iconLabels: Record<ActivityIcon, string> = {
  order: '📦',
  visit: '✓',
  call: '📞',
  note: '📝',
};

const iconColor: Record<ActivityIcon, string> = {
  order: 'order',
  visit: 'visit',
  call: 'call',
  note: 'note',
};

export const ActivityTimelineCard: React.FC<ActivityTimelineCardProps> = ({
  entries,
}) => {
  return (
    <div className={styles.card}>
      <h3 className={styles.title}>Activity Timeline</h3>
      <ul className={styles.timeline}>
        {entries.map((entry, idx) => (
          <li key={entry.id} className={styles.entry}>
            <span className={`${styles.icon} ${styles[iconColor[entry.icon]]}`}>
              {iconLabels[entry.icon]}
            </span>
            {idx < entries.length - 1 && <span className={styles.line} />}
            <div className={styles.body}>
              <p className={styles.entryTitle}>{entry.title}</p>
              <p className={styles.daysAgo}>{entry.daysAgo}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
